// useState es un gancho que permite convertir un dato de un componente en estado, la funcion devuelve el estado y una funcion para editarlo
// UseRef y useEffect se usa aqui para brindar accesibilidad a usuarios de teclado y screenreaders
import React, {useRef, useEffect, useState} from "react";
// Es una funcion que se usa aqui y en el componente padre App, se importa desde su propio archivo
import {usePrevious} from '../helpers/funcionUsePrevious';

// Declarar y exportar el componente al mismo tiempo
export default function Tarea(props) {
    // Toma un dato y devuelve arreglo con el estado y funcion para editarlo, se usa destructuring para almacenarlo en variables separadas
    // Se usara el estado bool para alternar entre los templates de la lista de tareas y la de editar una tarea usando RENDERING CONDICIONAL, por defecto es false
    const [editando, editarEditando] = useState(false);

    // Accesibilidad, para pasar la referencia a esos elementos
    // useRef es un gancho (hook) que crea un objeto con una sola propiedad (current), esta puede ser una referencia a lo que sea y se puede buscar despues, sirve para referenciar a elementos del DOM
    // Estas referencias llevan el valor null porque no van a tener valor hasta que se les empareje con sus respectivos elementos
    const editarCampoRef = useRef(null);
    const editarBotonRef = useRef(null);

    // Almacena el valor anterior de editando cuando este cambia, como es un toggler si editando cambia a true, el valor de aqui sera false y visceversa
    const estabaEditando = usePrevious(editando);
    // console.log(estabaEditando);

    // Accesibilidad termina

    function click() {
        // A medida que cambien los valores, la funcion para editar el estado va alternando entre templates
        if (editando) {
            editarEditando(false);
            // Se limpia el input
            editarNuevoNombre("");
        } else {
            editarEditando(true);
        }
    };

    // Toma un dato y devuelve arreglo con el estado y funcion para editarlo, se usa destructuring para almacenarlo en variables separadas
    const [nuevoNombre, editarNuevoNombre] = useState("");

    // Para detectar cambios en el imput
    function change(e) {
        // A medida que cambien los valores, la funcion para editar el estado va cambiando el valor del mismo estado (nombre)
        editarNuevoNombre(e.target.value);
    };

    // Maneja el envio del form, utiliza la funcion que se mandó como prop de App para devolver lo introducido en el input como el nombre de la tarea
    function submit(e) {
        e.preventDefault();
        props.editTarea(props.id, nuevoNombre);
        // Despues del envio del parametro a la funcion de App se limpia el input y manda al template de la lista de tareas
        editarNuevoNombre("");
        editarEditando(false);
    };

    // TEMPLATES

    // Template para editar una tarea
    const templateEditar = (
        // Al ser enviado el form, ejecuta la funcion submit
        <form className = "stack-small" onSubmit = {submit}>
            <div className = "form-group">
                <label className = "todo-label" htmlFor = {props.id}>Editar nombre para : <span className = "bold">"{props.nombre}"</span></label>

                {/* El valor del input es el estado (nombre) del componente Form */}
                {/* Al escribir el usuario, se ejecuta la funcion change */}
                <input id = {props.id} className = "todo-text" type = "text" value = {nuevoNombre} onChange = {change} required ref = {editarCampoRef} />
                {/* Ref propiedad de accesibilidad, ahora ya está emparejado el elemento con la referencia */}
            </div>

            <div className = "btn-group">
                <button type = "button" className = "btn btn__primary todo-edit cancel" onClick = {click}>Cancelar<span className = "visually-hidden">editar {props.nombre}</span></button>
                {/* Al pulsar, se ejecuta la funcion click */}

                <button type = "submit" className = "btn btn__primary todo-edit">Guardar<span className = "visually-hidden">cambios para {props.nombre}</span></button>
            </div>
        </form>
    )

    // Template para ver la lista de tareas completa
    const templateLista = (
        <div className = "stack-small">
            <div className = "c-cb">
                <input id = {props.id} type = "checkbox" defaultChecked = {props.completado} onChange = {() => props.toggleTareaCompletada(props.id)} />
                {/* Funcion para detectar el cambio en el checkbox, usar la callback function que se manda como prop desde App y darle el id del elemento seleccionado */}

                <label className = "todo-label" htmlFor = {props.id}>{props.nombre}</label>
            </div>

            <div className = "btn-group">
                {/* Ref propiedad de accesibilidad, ahora ya está emparejado el elemento con la referencia */}
                <button type = "button" className = "btn" onClick = {click} ref = {editarBotonRef}>Editar<span className = "visually-hidden">{props.nombre}</span></button>
                {/* Al pulsar, se ejecuta la funcion click */}

                <button type = "button" className = "btn btn__danger" onClick = {() => props.eliminarTarea(props.id)}>Eliminar<span className = "visually-hidden">{props.nombre}</span></button>
                {/* Funcion para detectar el click en el boton, usar la callback function que se manda como prop desde App y darle el id del elemento seleccionado */}
            </div>
        </div>
    )
    
    // Accesibilidad
    // useEffect toma una funcion como parametro y la ejecuta despues que el componente (Tarea) finaliza de renderizar y posteriormente puede correr cualquier nuevo comportamiento que se quiera agregar.
    // Es util aqui porque no se pueden enfocar los elementos hasta que se realice la interactividad de Editar una tarea y React sepa donde estan las referencias
    useEffect(() => {
        // Dependiendo del template en el que se esta (editar o lista de tareas), se llama al objeto que useRef creo y en su propiedad current se le indica que enfoque ese elemento

        // Si no estaba editando y ahora si...
        if(!estabaEditando && editando){
            editarCampoRef.current.focus(); // Enfocar el input
        }

        // Si estaba editando y ahora no (guardo o cancelo cambios)
        if(estabaEditando && !editando){
            editarBotonRef.current.focus(); // Enfocar boton de editar
        }
    }, [estabaEditando, editando]); // el segundo parametro que toma la funcion es un arreglo de variables a considerar para que solo se active la funcion cuando el valor de ambas o una de estas cambie, en este caso los bool de estabaEditando y editando


    // para ilustrar que useEffect carga despues de todo el render principal
    // console.log("Esto carga primero");

    return (
        // If anidado, dependiendo del estado bool para alternar entre templates
        <li className = "todo">{editando ? templateEditar : templateLista}</li>
    );
}  